/*
* LongTermLease/Comment API
* */

import {
    RequestConfigFunction,
} from 'app/types/request.types'

type LongTermLeaseCommentRequests = {
    filterRequestAll: RequestConfigFunction<{
        longTermLeaseId: number, params?: Record<string, any>
    }>,
    create: RequestConfigFunction<{longTermLeaseId: number}>,
    archive: RequestConfigFunction<{id: number}>,
}

const longTermLeaseCommentRequests: LongTermLeaseCommentRequests = {
    filterRequestAll: ({
        longTermLeaseId,
        params,
    }) => {
        return {
            url: `longtermlease/${longTermLeaseId}/comment/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    create: ({
        longTermLeaseId,
    }) => {
        return {
            url: `longtermlease/${longTermLeaseId}/comment`,
            method: 'POST',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `longtermlease/comment/${id}/archive`,
            method: 'PATCH',
        }
    },
}

export default longTermLeaseCommentRequests
